import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import StockChart from '../components/StockChart';
import './PageIndustriaAnio.css';

const DATA = [
  { year: 2010, value: 1934569 },
  { year: 2011, value: 2932008 },
  { year: 2012, value: 4110776 },
  { year: 2013, value: 4585711 },
  { year: 2014, value: 8187154 },
  { year: 2015, value: 13157066 },
  { year: 2016, value: 12017895 },
  { year: 2017, value: 12924027 },
  { year: 2018, value: 17359230 },
  { year: 2019, value: 16397671 },
  { year: 2020, value: 25417348 },
  { year: 2021, value: 40887060 },
  { year: 2022, value: 22038088 },
  { year: 2023, value: 16157661 },
  { year: 2024, value: 16967091 },
  { year: 2025, value: 11487116 },
];

const EVENTS = [
  { year: 2010, label: 'Porfirio Lobo' },
  { year: 2014, label: 'JOH (1er Término)' },
  { year: 2017, label: 'JOH Anuncia Reelección' },
  { year: 2020, label: 'COVID-19' },
  { year: 2022, label: 'Xiomara Castro' },
];

function PageIndustriaGobierno() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="industria-page">
        <header className="industria-header">
          <button className="btn-back" onClick={() => navigate('/industria-anio-transnacional')}>
            &#8592; Transnacional
          </button>
          <div className="industria-title-block">
            <h1 className="industria-title">Capital Gobierno</h1>
            <p className="industria-subtitle">Inversi&oacute;n publicitaria &middot; Gobierno &middot; Honduras 2010–2025 &middot; USD</p>
          </div>
          <button className="btn-next" onClick={() => navigate('/top-10-origen')}>
            Siguiente &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <StockChart data={DATA} color="#fbbf24" events={EVENTS} />

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageIndustriaGobierno;
